var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":false,"light":false,"id":"inspire"}},[_c('Snackbar'),_c('div',{staticClass:"aa-main"},[_c('Header'),_vm._t("default")],2),_c('aa-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }